import React, { useState, createContext } from 'react'
import PropTypes from 'prop-types'
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom'
import SqLanding from '~/components/SqLanding'
import SqCourseSearchPage from '~/components/sq/CourseSearchPage'
import WedLanding from '~/components/wed-oe/Landing'
import WedOeCourseCategoryPage from '~/components/wed-oe/CourseCategoryPage'
import WedOeCourseListPage from '~/components/wed-oe/CourseListPage'
import WedOeCourseDetailPage from '~/components/wed-oe/CourseDetailPage'
import StudentsPage from '~/components/StudentsPage'
import AddStudentPage from '~/components/AddStudentPage'
import AddIndustryStudentPage from '~/components/AddIndustryStudentPage'
import CartPage from '~/components/CartPage'
import ReceiptPage from '~/components/ReceiptPage'
import TermsOfUsePage from '~/components/TermsOfUsePage'
import PrivacyPage from '~/components/PrivacyPage'
import AccessbilityPage from '~/components/AccessbilityPage'
import Footer from '~/components/Footer'
import RefDataProvider from '~/refdata'
import { LoaderProvider } from './components/Loader'
import Header from '~/components/Header'
import WEDIndustryStudentRosterPage from '~/components/WEDIndustryStudentRosterPage'

// --vars
export const HeaderContext = createContext('')
export const defaultPageTitle = 'Francis Tuttle Technology Center'

// --components
function App ({ history }) {
  const [headerInfo, setHeaderInfo] = useState({ pageTitle: defaultPageTitle, showSqBanner: false, sqSeasonInfo: null })

  return (
    <LoaderProvider>
      <RefDataProvider>
        <HashRouter>
          <div className='base'>
            <HeaderContext.Provider value={{ headerInfo, setHeaderInfo }}>
              <Header />
              <main>
                <Switch>
                  <Route exact path='/summer-quest' component={SqLanding} />
                  <Route exact path='/lifelong-learning' component={WedLanding} />
                  <Route path='/terms' component={TermsOfUsePage} />
                  <Route path='/privacy' component={PrivacyPage} />
                  <Route path='/accessibility' component={AccessbilityPage} />
                  <Route exact path='/sq-courses' component={SqCourseSearchPage} />
                  <Route exact path='/ll-course-categories' component={WedOeCourseCategoryPage} />
                  <Route exact path='/ll-courses' component={WedOeCourseListPage} />
                  <Route exact path='/ll-courses/:id' component={WedOeCourseDetailPage} />
                  <Route exact path='/students' component={StudentsPage} />
                  <Route exact path='/addstudent' component={AddStudentPage} />
                  <Route exact path='/addindustrystudent' component={AddIndustryStudentPage} />
                  <Route exact path='/cart' component={CartPage} />
                  <Route exact path='/receipt/:id' component={ReceiptPage} />
                  <Route exact path='/industrystudentroster' component={WEDIndustryStudentRosterPage} />
                  <Route exact path='/' render={() => (<Redirect to='/ll-course-categories' />)} />
                </Switch>
              </main>
              <Footer />
            </HeaderContext.Provider>
          </div>
        </HashRouter>
      </RefDataProvider>
    </LoaderProvider>
  )
}

App.propTypes = {
  history: PropTypes.object
}

export default App
